
let SvgToBitmap = (file, w = 100, h= 100, type = 'png') => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        let canvas = document.createElement('canvas');
        img.onload = ()=>{
            let iw = img.width;
            let ih = img.height;
            let sw = iw/w;
            let sh = ih/h;
            let s = sw > sh ? sw : sh;

            canvas.width = iw / s;
            canvas.height = ih / s;
            let ctx = canvas.getContext('2d');
            if(type === 'jpeg') {
                ctx.fillStyle = "white";
                ctx.fillRect(0,0, canvas.width, canvas.height);
            }
            ctx.drawImage(img, 0 ,0, iw/s, ih/s);
            let base64 = canvas.toDataURL(`image/${type}`, 1);
            resolve(base64);

        }
        let fileReader = new FileReader();
        fileReader.onload = (e)=>{
            img.src = e.target.result;
        }
        fileReader.readAsDataURL(file);
    })
}

let SvgDocToBitmap = (svgDoc,  w = 100, h= 100, type = 'png')=>{
    return new Promise((resolve, reject) => {
        let img = new Image();
        let blob = new Blob([svgDoc],{type:'image/svg+xml;charset=utf-8'});
        let URL = window.URL || window.webkitURL || window;
        let blobURL = URL.createObjectURL(blob);
        img.src = blobURL;
        let canvas = document.createElement('canvas');
        img.onload = ()=>{
            let iw = img.width;
            let ih = img.height;
            let sw = iw/w;
            let sh = ih/h;
            let s = sw > sh ? sw : sh;

            canvas.width = iw / s;
            canvas.height = ih / s;
            let ctx = canvas.getContext('2d');
            if(type === 'jpeg') {
                ctx.fillStyle = "white";
                ctx.fillRect(0,0, canvas.width, canvas.height);
            }
            ctx.drawImage(img, 0 ,0, iw/s, ih/s);
            let base64 = canvas.toDataURL(`image/${type}`, 1);
            resolve(base64);
        }
    })
}

let SvgStringToWebP = (svgText, quality = 0.8)=>{
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgText);

        img.onload = () => {
            // Tạo canvas
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");

            // Vẽ SVG lên canvas
            ctx.drawImage(img, 0, 0);

            // Chuyển đổi sang WebP Blob
            canvas.toBlob(blob => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error("Failed to convert SVG to WebP"));
                }
            }, "image/webp", quality); // Chất lượng mặc định 80%
        };

        img.onerror = reject;
    });
}

export {SvgToBitmap, SvgDocToBitmap, SvgStringToWebP}